import { selectedShiftIdsSelector, toggleShift, updateShiftsSelectAllState } from 'pages/candidateOffer/store';
import { OccupationItemsWithFormattedDates } from 'pages/candidateOffer/types';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { OfferItemsScheduleList, OfferSingleItemScheduleList } from '../../components';

export default function ShiftsScheduleList({ items }: { items: OccupationItemsWithFormattedDates[] }) {
    const dispatch = useDispatch();
    const selectedShiftIds = useSelector(selectedShiftIdsSelector);

    const handleSelectAllChange = useCallback(() => {
        dispatch(updateShiftsSelectAllState());
    }, [ dispatch ]);

    const handleChange = useCallback((shiftId: string) => {
        dispatch(toggleShift({ shiftId }));
    }, [ dispatch ]);

    if (items.length === 1) {
        return <OfferSingleItemScheduleList item={ items[0] } />;
    }

    return (
        <OfferItemsScheduleList items={ items }
            onSelectAllClick={ handleSelectAllChange }
            onSelect={ handleChange }
            translationSection="shiftsPage"
            selectedIds={ selectedShiftIds }
        />
    );
}
